/** Admin topbar va ochiq sayt (landing) — bir xil kalit, mavzu sinxron. */
export const SITE_THEME_STORAGE_KEY = 'admin-theme';

export function getStoredSiteTheme(): 'light' | 'dark' {
  try {
    const v = localStorage.getItem(SITE_THEME_STORAGE_KEY);
    if (v === 'dark' || v === 'light') {
      return v;
    }
  } catch {
    // ignore
  }
  return 'light';
}

export function setStoredSiteTheme(theme: 'light' | 'dark'): void {
  try {
    localStorage.setItem(SITE_THEME_STORAGE_KEY, theme);
  } catch {
    // ignore
  }
}

export function applySiteThemeToDocument(theme: 'light' | 'dark'): void {
  if (typeof document === 'undefined') {
    return;
  }
  document.documentElement.setAttribute('data-theme', theme);
}
